module.exports = __webpack_public_path__ + "static/img/16bg_2.568280b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_2.png
// module id = 658
// module chunks = 1